export const enum BleDeviceTypes {
  ELECTRONIC_BLOOD_PRESSURE_MONITOR = 1,
  MEDICAL_BLOOD_PRESSURE_MONITOR = 2,
  ELECTRONIC_THERMOMETER = 3,
  BLOOD_SUGAR_LEVEL_MEASUREMENT = 4,
  SPO2_MONITOR_MIGHTY_SAT = 5,
  ECG_SERVICE = 6,
  SPO2_MONITOR_TM1121 = 7,
  NONCONTACT_THERMOMETER = 9,
  BODY_COMPOSITION_MONITOR = 10
}

export const bleDeviceNames = {
  [BleDeviceTypes.ELECTRONIC_BLOOD_PRESSURE_MONITOR]: '電子血圧計 NBP-1BLE',
  [BleDeviceTypes.MEDICAL_BLOOD_PRESSURE_MONITOR]: '医科向け血圧計 UM-212',
  [BleDeviceTypes.ELECTRONIC_THERMOMETER]: '電子体温計 NSM-1BLE',
  [BleDeviceTypes.BLOOD_SUGAR_LEVEL_MEASUREMENT]: '血糖測定器 ケアファストLink',
  [BleDeviceTypes.SPO2_MONITOR_MIGHTY_SAT]: 'SPO2モニター MightySat',
  [BleDeviceTypes.ECG_SERVICE]: '心電送信機 Cocoron',
  [BleDeviceTypes.SPO2_MONITOR_TM1121]: 'SPO2モニター TM1121',
  [BleDeviceTypes.NONCONTACT_THERMOMETER]: '非接触体温計 NT-100B',
  [BleDeviceTypes.BODY_COMPOSITION_MONITOR]: '体組成計 NBCM'
}

export const enum EcgTermHR {
  TERM_5 = 5,
  TERM_10 = 10,
  TERM_30 = 30,
  TERM_60 = 60
}

export const DEFAULT_ECG_TERM_HR = EcgTermHR.TERM_5
export const DEFAULT_CONSTANT_ECG = true
export const EQUIPPED_CHECK_COUNT = 3
export const LOW_BATTERY_BORDER = 2300
export const PR_RESET_INTERVAL = 70000
export const ECG_SAVE_SECONDS = 60
